import * as React from 'react';
import { observer } from 'mobx-react';
import { formatDate, parseDate, getDateLimitForCycle } from 'utils/dateUtils';
import * as actions from 'nomst/Actions/configurations';
import './cycleDateSection.scss';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { CustomDatePicker } from 'nomst/Components/Utils/customDatePicker';

export interface ICycleDateSectionProps {
    isDisabled: boolean;
    configuration: Configuration;
}

export class CycleDateSection extends React.Component<ICycleDateSectionProps> {
    _maxDateLimt: Date;
    _minDateLimit: Date;
    constructor(props: ICycleDateSectionProps) {
        super(props);

        this.handlePayEffectiveDateChange = this.handlePayEffectiveDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this._maxDateLimt = getDateLimitForCycle(true, 10);
        this._minDateLimit = getDateLimitForCycle(false, 10);
    }

    render(): React.ReactNode {
        const { isDisabled, configuration } = this.props;
        if (!configuration) {
            return null;
        }

        return (
            <div className="cycle-date-section">
                <h3 className="cycle-date-section__heading">Review Cycle</h3>
                <div className="cycle-date-section__dates">
                    <div className="cycle-date-section__date">
                        <label htmlFor="cycleStartDate">Cycle Start Date</label>
                        <CustomDatePicker
                            id="cycleStartDate"
                            value={parseDate(configuration.startDate)}
                            disabled={true}
                            clearIcon={null}
                        />
                    </div>
                    <div className="cycle-date-section__date">
                        <label htmlFor="finalApprovalDate">Final Approval Date</label>
                        <CustomDatePicker
                            id="finalApprovalDate"
                            value={parseDate(configuration.endDate)}
                            onChange={this.handleEndDateChange}
                            clearIcon={null}
                            disabled={isDisabled}
                            minDateValue={this._minDateLimit}
                            maxDateValue={this._maxDateLimt}
                        />
                    </div>
                    <div className="cycle-date-section__date">
                        <label htmlFor="payEffectiveDate">Pay Effective Date</label>
                        <CustomDatePicker
                            id="payEffectiveDate"
                            value={parseDate(configuration.payEffectiveDate)}
                            onChange={this.handlePayEffectiveDateChange}
                            clearIcon={null}
                            disabled={isDisabled}
                            minDateValue={this._minDateLimit}
                            maxDateValue={this._maxDateLimt}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private handlePayEffectiveDateChange(value: Date): Promise<void>  {
        return actions.setPayEffectiveDate(formatDate(value).toString());
    }

    private handleEndDateChange(value: Date): Promise<void>  {
        return actions.setCycleEndDate(formatDate(value).toString());
    }
}

export default observer(CycleDateSection);